import { type SortDirection } from 'types/enums'

import { ViewLikesContextActionType } from '../../types'
import { useViewLikesDispatch } from '../../ViewLikesContext'

export const setDirection = (direction: SortDirection) => {
    const dispatch = useViewLikesDispatch()
    dispatch({
        type: ViewLikesContextActionType.SET_SORT_DIRECTION,
        payload: direction
    })
}
